import { render } from "./Home.vue?vue&type=template&id=15674bfc&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=15674bfc&scoped=true&lang=css"

import exportComponent from "D:\\code2\\demo2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15674bfc"]])

export default __exports__